const genericMediaErrorMessageDE =
  'Fehler beim Zugriff auf Kamera/Mikrofon. Stellen Sie sicher, dass sie nicht von einer anderen Anwendung verwendet werden.';

export type PermissionResult = { status: 'granted' } | { status: 'denied' } | { status: 'error'; message: string };

/**
 * Requests camera and microphone permissions using the browser's
 * navigator.mediaDevices.getUserMedia API.
 *
 * @returns {Promise<PermissionResult>} A promise resolving to an object indicating the outcome.
 */
export async function requestBrowserPermissions(): Promise<PermissionResult> {
  if (!navigator.mediaDevices?.getUserMedia) {
    console.error('Browser does not support getUserMedia.');

    return { status: 'error', message: 'Ihr Browser unterstützt den Zugriff auf Kamera/Mikrofon nicht.' };
  }

  try {
    await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    console.log('Browser permissions granted via getUserMedia.');

    return { status: 'granted' };
  } catch (err) {
    console.error('Error requesting browser permissions:', err);
    if (err instanceof Error && err.name === 'NotAllowedError') {
      console.log('User denied browser permissions.');

      return { status: 'denied' };
    }

    return { status: 'error', message: genericMediaErrorMessageDE };
  }
}
